// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"9d6bb96b","67":"e5efd6f5","156":"bb83325d","289":"732b38a7","374":"bb49329c","476":"6f2011fd","516":"91cdd628","679":"61530596","714":"bbb3aae1","732":"a044b596","774":"e70ec6c7","870":"044dc58a","888":"dddb9bf7","960":"e0734f24"}[chunkId] + ".chunk.js";
};